import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { DownwardArrowIcon, UpwardArrowIcon } from "../assets/ArrowIcons";

type AccordionDropdownProps = {
  title: string;
  children: any;
  defaultOpen?: boolean;
  errors?: any;
  openPopupButton?: any;
};

const AccordionDropdown = ({
  title,
  children,
  defaultOpen = false,
  errors,
  openPopupButton,
}: AccordionDropdownProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    // If there are any errors, open the accordion
    if (errors && Object.keys(errors).length > 0) {
      setIsOpen(true);
      setIcon(<UpwardArrowIcon color="#242424" />);
    }
  }, [errors]);

  const [icon, setIcon] = useState<any>(
    defaultOpen ? (
      <UpwardArrowIcon color="#242424" />
    ) : (
      <DownwardArrowIcon color="#242424" />
    )
  );
  const handleDropdown = () => {
    setIsOpen(!isOpen);
    setIcon(
      !isOpen ? (
        <UpwardArrowIcon color="#242424" />
      ) : (
        <DownwardArrowIcon color="#242424" />
      )
    );
  };

  return (
    <div className="w-[100%] flex flex-col items-center m-auto ">
      <div
        className={`cursor-pointer w-full flex flex-row justify-between border border-[#D9D9D9]  bg-white items-center font-outfit-bold  ${
          !isOpen ? "" : "border-b-0"
        }`}
        onClick={handleDropdown}
      >
        <div className="flex flex-row ">
          <p className="px-4 py-2 font-roboto-condensed font-bold text-pot-yellow uppercase">
            {title}
          </p>
        </div>
        <div className="flex flex-row justify-end items-center gap-4">
          <div onClick={(e) => e.stopPropagation()}>{openPopupButton}</div>
          <div className="h-full mr-4 cursor-pointer" onClick={handleDropdown}>
            {icon}
          </div>
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              duration: 0.3,
              ease: "easeInOut",
            }}
            className="w-full overflow-visible"
          >
            <div className="flex flex-col justify-around space-y-5 text-sm px-4 pt-4 pb-2 border border-[#D9D9D9]">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AccordionDropdown;
